/**
 * Copyright (C) Sitevision 2002-2024, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-userprofile-portlet')) {
  import(
    /* webpackChunkName: "userprofile-portlet" */ '../util/static/selfserviceFieldset.css'
  );
}
